'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DeletingOverlay = require('./components/DeletingOverlay.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DeletingOverlay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/deleting-overlay/index.js
// module id = 1287
// module chunks = 0